import { EventKey } from '../event-bus';

export const sendCustomGAEvent = (
  eventName: string,
  eventParams: Object,
): void => {
  if (window.gtag === undefined) {
    console.warn('gtag is not initialized');
    return;
  }

  if (eventName === EventKey.LoginUser) {
    eventName = 'login';
  }

  return window.gtag('event', eventName, eventParams);
};
